import { getOperatingHoursToUpdate } from './transformOperatingHours'
import { getOrderAheadHoursToUpdate } from './transformOrderAheadHours'

export const getHandleChangeOrderAheadHours = (
  hours,
  orderAheadHours,
  values,
  currentMenu,
  setFieldValue,
  setShowValidationErrors
) => {
  const { dayName, startTime, endTime, disabled, type } = hours

  const ordersToUpdate = {
    ...orderAheadHours,
    [dayName]: {
      startTime: startTime ?? '',
      endTime: endTime ?? '',
      disabled: disabled ?? false,
      type: type ?? '',
    },
  }

  const orderAheadHoursToUpdate =
    getOrderAheadHoursToUpdate(ordersToUpdate)

  const updatedMenus = values?.menus.map((menu) => {
    if (menu.uuid === currentMenu.uuid) {
      return {
        ...menu,
        orderAheadHours: orderAheadHoursToUpdate,
      }
    }

    return menu
  })

  setFieldValue('menus', updatedMenus).then(() =>
    setShowValidationErrors(false)
  )
}

export const getHandleChangeOperatingHours = (
  hours,
  operatingHours,
  values,
  currentMenu,
  setFieldValue,
  setShowValidationErrors
) => {
  const { dayName, startTime, endTime, disabled, type } = hours

  const ordersToUpdate = {
    ...operatingHours,
    [dayName]: [
      {
        startTime: startTime ?? '',
        endTime: endTime ?? '',
        disabled: disabled ?? false,
        type: type ?? '',
      },
    ],
  }

  const operatingHoursToUpdate =
    getOperatingHoursToUpdate(ordersToUpdate)

  const updatedMenus = values?.menus.map((menu) => {
    if (menu.uuid === currentMenu.uuid) {
      return {
        ...menu,
        operatingHours: operatingHoursToUpdate,
      }
    }

    return menu
  })

  setFieldValue('menus', updatedMenus).then(() =>
    setShowValidationErrors(false)
  )
}
